import * as yup from "yup";

export default yup.object().shape({
  synonyms: yup
    .array()
    .min(1, "You need at least one synonym to save a set")
    .test("synonyms", "Only unique values allowed", value => (value ? value.length === new Set(value)?.size : true))
    .required("Synonyms are required"),
});
